// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";

const resetStaleTurboFormState = () => {
  document.querySelectorAll("form[aria-busy='true']").forEach((form) => {
    form.removeAttribute("aria-busy");

    form
      .querySelectorAll(
        "button[type='submit'][disabled][aria-disabled='true'], button:not([type])[disabled][aria-disabled='true'], input[type='submit'][disabled][aria-disabled='true']"
      )
      .forEach((submitter) => {
        submitter.removeAttribute("disabled");
        submitter.removeAttribute("aria-disabled");
      });
  });
};

document.addEventListener("turbo:before-cache", resetStaleTurboFormState);
